export class LanguageAdmin {
    id: number = -2;
    globalId: string = '';
    languageId: number = -1;
}